import React from 'react';
import Menu from './Menu';
import '../../css/elements/left-sidebar-1.css';
import hasAccess from "../../helpers/permissionChecker";

const LeftSidebar = ({ navigation, auth, users, layout, menuShow }) => {

  if (menuShow === false) {
    return (<div></div>);
  }
  const menu = navigation.map((menu, i) => {
    return (
      <div key={i} className="section">
        <ul className="list-unstyled" style={{ paddingTop: '15px' }}>
          {
            menu.items.map((items, i) => {
              if (hasAccess(items.permissions)) {
                return (<Menu key={i} items={items}/>);
              } else {
                return null;
              }
            })
          }
        </ul>
      </div>
    );
  });

  return (
    <div>
      <div className="left-sidebar-placeholder"/>
      <div className="left-sidebar left-sidebar-1">
        <div className="wrapper">
          <div className="content">
            {menu}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftSidebar;



// WEBPACK FOOTER //
// ./src/elements/left-sidebar/LeftSidebar.js